import axios from 'axios';
import * as endpoint from '../../../endpoint';
import { consolelog, delCancelToken, showToast } from '../../../../lib/tools';
import {
  createCancelToken,
  handleErrorResponse,
  handleErrorResponseType,
  i18nMessages,
} from '../../apis';
import { configureAxiosForJSON } from '../../axiosConfig';

/**
 * タグ情報マスタのタグ名・利用フラグを更新する
 *
 * @param {string} apiToken - API通信に使用するトークン。
 * @param {Object} options - APIリクエストのオプション。`id`（更新するタグのID）、
 *                           `name`（新しいタグ名）、`isUsable`（使用可能状態）を含む。
 * @returns {Function} Redux dispatch関数
 */
const updateTags = (apiToken, options) => dispatch => {
  consolelog('[API CALL] updateTags()');
  configureAxiosForJSON(apiToken);
  const url = endpoint.API_UPDATE_TAGS.replace('{id}', options.id);
  const { cancelToken, cancelTokenKey } = createCancelToken('updateTags');
  const params = {
    cancelToken,
    name: options.name,
    isUsable: options.isUsable,
  };

  return axios
    .patch(url, params)
    .then(() => {
      delCancelToken(cancelTokenKey);
      // TODO: タグ更新時のdispatchアクション
      showToast(i18nMessages['toast.message.tag.update']);
    })
    .catch(thrown => {
      delCancelToken(cancelTokenKey);
      if (!axios.isCancel(thrown)) {
        handleErrorResponse(thrown, dispatch, handleErrorResponseType.tags);
      }
    })
    .finally(() => {
      dispatch({ type: 'CLOSE_EDIT_MASTER_DIALOG' });
    });
};

export default updateTags;
